import { IDS } from '../../import-settings-action-id.constants';
import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import * as SettingsActions from '../../import-settings.actions';
import watch from "redux-watch";

class UsersRelocatedGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
    }

    $onInit() {
        this.module = IDS.employees;
        this.identifier = IDS.empImportSettings;
        this.statePath = IDS.empImportSettingsUsersRelocatedListGrid;
        //this.filterTemplate = './users-relocated-grid-filter.html';
        this.exportComponent = false;
        this.title = false;
        this.icon = false;
        this.confirmDialogOnRemove = true;
        //this.autoload = false;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;

        this.columns = [
            {title: '#',            mapper: null},
            {title: 'Name',         mapper: 'name'},
            {title: 'Email',        mapper: 'email'},
            {title: 'State',        mapper: 'sta_id'},
            {title: 'Site Name',    mapper: 'site_name'},
            {title: 'Cost Center',  mapper: 'cost_center_number'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), SettingsActions)(this);

        const $rootScope = this.$rootScope;
        const watchReset = watch(this.$ngRedux.getState, `${this.module}.${this.identifier}.${this.statePath}.reset`);
        this.unsubscribeOnReset = this.$ngRedux.subscribe(watchReset(function() {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'empImportSettingsUsersRelocatedGridFilterForm');
        }));

        this.dataAction = this.fetchUsersRelocatedListGrid;
        this.init();
    }

    $onDestroy() {
        if(this.unsubscribeOnReset)
            this.unsubscribeOnReset()

        this.destroy();
    }

}

UsersRelocatedGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const empImportSettingsUsersRelocatedListGrid = {
    bindings: {
        onSelect: '&',
        title: '@'
    },
    controller: UsersRelocatedGridController,
    ...gridTpl
}
